import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { vnApp_ads_ninja } from '../vnApp_ads_ninja';

declare var ko: any;

export class floorList_template extends vnTemplate{

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        // TODO: Make middle table vertical scroll with limit of 10 rows.

        return `
            <style>
                .list-results tbody tr td {
                    border-right: 1px solid #191d21;
                }
                .flex {
                    justify-content: flex-start;
                }
                .flex span {
                    display: contents !important;
                }
            </style>

            <div class="list-header w-justify margin-top"> 
                <div class="w-left" data-bind="if: hasWriteAccess">
                    <button data-bind="click: onClickAdd" class="btn icon i-add" type="button">Add Floor</button>
                </div>
            </div>
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-bid-floor">Bidstream Floors</h2>
                </div>
            </div>            
            <div class="w-list-results">
                <table class="list-results">
                    <thead> 
                        <tr>
                            <th class="narrow"><span>Note</span></th>
                            <!-- ko if: idBrand -->
                                <th class="narrow highlight border-right"><span>Level</span></th>
                            <!-- /ko -->
                            <!-- ko if: idBrand -->
                                <th class="narrow highlight border-right"><span>Ad Setup</span></th>
                            <!-- /ko -->
                            <th class="narrow highlight border-right"><span>Device Type</span></th>
                            <th class="narrow"><span>Geo</span></th>                        
                            <th class="narrow"><span>Zone</span></th>
                            <th class="narrow"><span>Parent Zone</span></th>
                            <th class="narrow"><span>Media Type</span></th>
                            <th class="narrow"><span>Dimensions</span></th>
                            <th class="narrow"><span>Bidder Type</span></th>
                            <th class="narrow"><span>Value</span></th>
                            <th class="narrow"><span>Actions</span></th>    
                        </tr> 
                    </thead>
                    <tbody data-bind="foreach: bidstreamFloors" style="color: white;">  
                        <tr>
                            <td><span data-bind="text: note"></span></td>
                            <!-- ko if: $parent.idBrand -->
                                <td class="highlight"> 
                                    <span>
                                        <!-- ko if: idBrand --> 
                                            Brand
                                        <!-- /ko -->
                                        <!-- ko ifnot: idBrand -->
                                            Network
                                        <!-- /ko -->
                                    </span>
                                </td>
                            <!-- /ko -->
                            <!-- ko if: $parent.idBrand -->
                                <td class="highlight"><span data-bind="text: adSetupName"></span></td>
                            <!-- /ko -->
                            <td class="highlight"><span data-bind="text: deviceTypeName"></span></td>
                            <td><span data-bind="text: geoName"></span></td>
                            <td><span data-bind="text: zoneName"></span></td>
                            <td><span data-bind="text: parentZoneName"></span></td>
                            <td><span data-bind="text: mediaTypeName"></span></td>
                            <td><span data-bind="text: dimensionsName"></span></td>
                            <td><span data-bind="text: bidderTypeName"></span></td>
                            <td><span data-bind="text: '$' + Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="flex">
                                <span>
                                    <!-- ko if: $parent.idBrand -->
                                        <!-- ko if: idBrand --> 
                                            <a title="Edit Floor" data-bind="attr: {href: '/brand/' + idBrand + '/floors/edit/' + id, class: 'btn icon-only icon i-edit'}, visible: $parent.hasUpdateAccess"><span class="hidden-text"></span></a>
                                            <a title="Copy Floor" data-bind="attr: {href: '/brand/' + idBrand + '/floors/copy/' + id, class: 'btn icon-only icon i-copy'}, visible: $parent.hasWriteAccess"><span class="hidden-text"></span></a>    
                                            <button data-bind="visible: $parent.hasDeleteAccess, event: { click: $parent.onClickDelete }" class="btn icon-only icon i-delete" type="button"><span class="hidden-text"></span></button>
                                        <!-- /ko -->
                                        <!-- ko ifnot: idBrand -->
                                            <a title="Go To Floors for Network" data-bind="attr: {href: '/floors', class: 'btn icon-only icon i-bid-floor'}, visible: $parent.hasReadAccess"></a>  
                                        <!-- /ko -->
                                    <!-- /ko -->
                                    <!-- ko ifnot: $parent.idBrand -->
                                        <a title="Edit Floor" data-bind="attr: {href: '/floors/edit/' + id, class: 'btn icon-only icon i-edit'}, visible: $parent.hasUpdateAccess"><span class="hidden-text"></span></a>  
                                        <a title="Copy Floor" data-bind="attr: {href: '/floors/copy/' + id, class: 'btn icon-only icon i-copy'}, visible: $parent.hasWriteAccess"><span class="hidden-text"></span></a>  
                                        <button data-bind="visible: $parent.hasDeleteAccess, event: { click: $parent.onClickDelete }" class="btn icon-only icon i-delete" type="button"><span class="hidden-text"></span></button>
                                    <!-- /ko -->
                                </span>
                            </td>  
                        </tr>      
                    </tbody>
                </table>
            </div>
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-bid-floor">Local Floors</h2>
                </div>
            </div>                
            <div class="w-list-results">
                <table class="list-results">
                    <thead> 
                        <tr>
                            <th class="narrow"><span>Note</span></th>
                            <!-- ko if: idBrand -->
                                <th class="narrow highlight border-right"><span>Level</span></th>
                            <!-- /ko -->
                            <!-- ko if: idBrand -->
                                <th class="narrow highlight border-right"><span>Ad Setup</span></th>
                            <!-- /ko -->
                            <th class="narrow highlight border-right"><span>Device Type</span></th>
                            <th class="narrow"><span>Geo</span></th>
                            <th class="narrow"><span>Zone</span></th>
                            <th class="narrow"><span>Parent Zone</span></th>
                            <th class="narrow"><span>Media Type</span></th>
                            <th class="narrow"><span>Dimensions</span></th>
                            <th class="narrow"><span>Bidder Type</span></th>
                            <th class="narrow"><span>Bidder</span></th>
                            <th class="narrow"><span>Value</span></th>
                            <th class="narrow"><span>Actions</span></th>   
                        </tr> 
                    </thead>
                    <tbody data-bind="foreach: localFloors" style="color: white;">  
                        <tr>
                            <td><span data-bind="text: note"></span></td>
                            <!-- ko if: $parent.idBrand -->
                                <td class="highlight"> 
                                    <span>
                                        <!-- ko if: idBrand --> 
                                            Brand
                                        <!-- /ko -->
                                        <!-- ko ifnot: idBrand -->
                                            Network
                                        <!-- /ko -->
                                    </span>
                                </td>
                            <!-- /ko -->
                            <!-- ko if: $parent.idBrand -->
                                <td class="highlight"><span data-bind="text: adSetupName"></span></td> 
                            <!-- /ko -->
                            <td class="highlight"><span data-bind="text: deviceTypeName"></span></td>
                            <td><span data-bind="text: geoName"></span></td>
                            <td><span data-bind="text: zoneName"></span></td>
                            <td><span data-bind="text: parentZoneName"></span></td>
                            <td><span data-bind="text: mediaTypeName"></span></td>
                            <td><span data-bind="text: dimensionsName"></span></td>
                            <td><span data-bind="text: bidderTypeName"></span></td>
                            <td><span data-bind="text: bidderName"></span></td>
                            <td><span data-bind="text: '$' + Number(value).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="flex">
                                <span>
                                    <!-- ko if: $parent.idBrand -->
                                        <!-- ko if: idBrand --> 
                                            <a title="Edit Floor" data-bind="attr: {href: '/brand/' + idBrand + '/floors/edit/' + id, class: 'btn icon-only icon i-edit'}, visible: $parent.hasUpdateAccess"><span class="hidden-text"></span></a>  
                                            <a title="Copy Floor" data-bind="attr: {href: '/brand/' + idBrand + '/floors/copy/' + id, class: 'btn icon-only icon i-copy'}, visible: $parent.hasWriteAccess"><span class="hidden-text"></span></a>  
                                            <button data-bind="visible: $parent.hasDeleteAccess, event: { click: $parent.onClickDelete }" class="btn icon-only icon i-delete" type="button"><span class="hidden-text"></span></button>
                                        <!-- /ko -->
                                        <!-- ko ifnot: idBrand -->
                                            <a title="Go To Floors for Network" data-bind="attr: {href: '/floors', class: 'btn icon-only icon i-bid-floor'}, visible: $parent.hasReadAccess"></a>  
                                        <!-- /ko -->
                                    <!-- /ko -->
                                    <!-- ko ifnot: $parent.idBrand -->
                                        <a title="Edit Floor" data-bind="attr: {href: '/floors/edit/' + id, class: 'btn icon-only icon i-edit'}, visible: $parent.hasUpdateAccess"><span class="hidden-text"></span></a>  
                                        <a title="Copy Floor" data-bind="attr: {href: '/floors/copy/' + id, class: 'btn icon-only icon i-copy'}, visible: $parent.hasWriteAccess"><span class="hidden-text"></span></a>  
                                        <button data-bind="visible: $parent.hasDeleteAccess, event: { click: $parent.onClickDelete }" class="btn icon-only icon i-delete" type="button"><span class="hidden-text"></span></button>
                                    <!-- /ko -->
                                </span>
                            </td>  
                        </tr>      
                    </tbody>
                </table>
            </div>

            <!-- ko ifnot: idBrand -->
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-bid-floor">Brand Floors</h2>
                </div>
            </div>               
            <div class="w-list-results">
                <table class="list-results">
                    <thead> 
                        <tr>
                            <th class="narrow"><span>Brand</span></th>
                            <th class="narrow"><span>Number of Bidstream Floors</span></th>
                            <th class="narrow"><span>Number of Local Floors</span></th>
                            <th class="narrow"><span>Actions</span></th>    
                        </tr> 
                    </thead>
                    <tbody data-bind="foreach: numberOfFloorsPerBrand" style="color: white;">  
                        <tr>
                            <td><span data-bind="text: brandName"></span></td>
                            <td><span data-bind="text: numberOfFloorsBidstream"></span></td>
                            <td><span data-bind="text: numberOfFloorsLocal"></span></td>
                            <td class="flex">
                                <span>
                                    <a title="Go To Floors for Brand" data-bind="attr: {href: '/brand/' + idBrand + '/floors', class: 'btn icon-only icon i-bid-floor'}, visible: $parent.hasReadAccess"></a>  
                                </span>
                            </td>  
                        </tr>      
                    </tbody>
                </table>
            </div>
            <!-- /ko -->
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'floorList_template';
    }

    /**
     * @inheritDoc
     */
    protected getMainElementClasses(): Array<string>{

        return [];
    }

    /**
     * @inheritDoc
     */
    public activateLoading(): void{

        this.getTemplateViewModel().isLoading(1);
    }

    /**
     * @inheritDoc
     */
    public deactivateLoading(): void{

        this.getTemplateViewModel().isLoading(0);
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object{

        let self    = this;
        let idBrand = this.caller.getBrandId();

        return {
            idBrand: ko.observable(idBrand),
            orderBy: ko.observable(''),
            orderByDirection: ko.observable(''),
            orderByAndDirection: ko.observable(''),
            bidstreamFloors: ko.observableArray([]),
            localFloors: ko.observableArray([]),
            numberOfFloorsPerBrand: ko.observableArray([]),
            hasReadAccess: ko.observable(this.caller.hasAccessToSection(vnApp_ads_ninja.SECTION_ID_ZONE, vnApp_ads_ninja.ACCESS_TYPE_READ)),
            hasUpdateAccess: ko.observable(this.caller.hasAccessToSection(vnApp_ads_ninja.SECTION_ID_ZONE, vnApp_ads_ninja.ACCESS_TYPE_UPDATE)),
            hasDeleteAccess: ko.observable(this.caller.hasAccessToSection(vnApp_ads_ninja.SECTION_ID_ZONE, vnApp_ads_ninja.ACCESS_TYPE_DELETE)),
            hasWriteAccess: ko.observable(this.caller.hasAccessToSection(vnApp_ads_ninja.SECTION_ID_ZONE, vnApp_ads_ninja.ACCESS_TYPE_WRITE)),
            onClickEdit: function(data, event){ self.onClickEdit(data.id); },
            onClickAdd: function(){ self.onClickAdd(); },
            onClickDelete: function(data){ self.onClickDelete(data); },
            onClickGoTo: function(data){ self.onClickGoTo(data); },
            getBooleanRepresentation: function(value){ return self.getBooleanRepresentation(value); },
        };
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        return {
            idBrand: this.caller.getBrandId(),
        };
    }

    //
    // Sets list data.
    public setListData(data): void{

        this.getTemplateViewModel().bidstreamFloors((data.bidstreamFloors && typeof data.bidstreamFloors === 'object') ? Object.keys(data.bidstreamFloors).map(function(key){ return data.bidstreamFloors[key]; }) : data.bidstreamFloors);
        this.getTemplateViewModel().localFloors((data.localFloors && typeof data.localFloors === 'object') ? Object.keys(data.localFloors).map(function(key){ return data.localFloors[key]; }) : data.localFloors);
        this.getTemplateViewModel().numberOfFloorsPerBrand((data.numberOfFloorsPerBrand && typeof data.numberOfFloorsPerBrand === 'object') ? Object.keys(data.numberOfFloorsPerBrand).map(function(key){ return data.numberOfFloorsPerBrand[key]; }) : data.numberOfFloorsPerBrand);
    }

    //
    // Handles the add user action.
    public onClickAdd(){

        this.caller.add();
    }

    //
    // Handles on edit button click event.
    public onClickEdit(id){

        this.caller.edit(id);
    }

    //
    // Handles on delete button click event.
    public onClickDelete(data){

        this.caller.confirmationModal.setTitle('Confirm Deletion');
        this.caller.confirmationModal.setContext('delete');
        this.caller.confirmationModal.setMessageMain('Are you sure you would like to delete this floor?');
        this.caller.confirmationModal.setDataConfirm(data.id);
        this.caller.confirmationModal.setMessageSecondary(data.name);
        this.caller.confirmationModal.show();
    }

    //
    // String representation of column.
    private getBooleanRepresentation(value){

        return (value) ? 'yes' : 'no';
    }

    //
    // Handles on go to button click event.
    public onClickGoTo(data){

        if(data.numberOfFloors){
            
            this.caller.goTo(data.idBrand);
        }
        else{

            this.caller.goTo(null);
        }
    }
}